<script>
import Layout from '../../components/Layout'
import CommonTable from '../../components/CommonTable'
import { mapState, mapActions } from 'vuex'
import FormFilter from './FormFilter'
import { rolePermissionCheck } from '../../permission/rolePermission'

export default {
	name: 'AuditLogs',
	components: {
		CommonTable,
		Layout,
		FormFilter
	},
	data() {
		return {
			columns: [
				{
					name: 'createdAt',
					label: 'Created At',
					field: 'createdAt',
					format: this.$dateUtils.unaryFormat,
					align: 'left',
					sortable: true,
					style: 'min-width: 180px; max-width: 240px'
				},
				{
					name: 'userId',
					label: 'User ID',
					field: 'userId',
					align: 'left',
					style: 'min-width: 95px; max-width: 120px'
				},
				{
					name: 'orderId',
					label: 'Order ID',
					field: 'orderId',
					align: 'left',
					style: 'min-width: 250px'
				},
				{
					name: 'deliveryId',
					label: 'Delivery ID',
					field: 'deliveryId',
					align: 'left',
					style: 'min-width: 250px'
				},
				{
					name: 'action',
					label: 'Action',
					field: 'action',
					align: 'left',
					style: 'min-width: 190px; max-width: 250px'
				},
				{
					name: 'status',
					label: 'Status',
					field: 'status',
					align: 'left',
					style: 'min-width: 150px; max-width: 200px'
				},
				{
					name: 'detail',
					label: 'Detail',
					align: 'left',
					style: 'min-width: 90px; max-width: 120px'
				}
			]
		}
	},
	computed: {
		...mapState('auditLogs', ['totalPage', 'data']),
		detailPermission() { return rolePermissionCheck('audit-logs', 'detail') }
	},
	methods: {
		...mapActions('auditLogs', ['getAuditLogs', 'updateFilter']),
		async onPageChange(pagination) {
			const { sortKey, descending, rowsPerPage, page } = pagination
			const sortBy = sortKey || 'createdAt'
			const sortDirection = sortKey ? (descending ? 'DESC' : 'ASC') : 'DESC'
			const currPage = page? page : 1
			const currRowsPerPage = rowsPerPage? rowsPerPage : 100

			await this.getAuditLogs({
				sortBy,
				sortDirection,
				page: currPage,
				limit: currRowsPerPage
			})
		}
	}
}
</script>

<template>
	<layout class-name="audit-log-page" title="Audit Logs">
		<form-filter />
		<common-table
			row-key="id"
			:data="data"
			:columns="columns"
			:on-page-change="onPageChange"
			:total-page="totalPage"
			binary-state-sort
		>
			<template #detail="{ row }" v-if="detailPermission">
				<router-link
					title="details"
					:to="{ path: `audit-logs/${row.id}` }"
				>
					🗒️
				</router-link>
			</template>
		</common-table>
	</layout>
</template>

<style lang="scss">
.audit-log-page {
	display: flex;
}
.q-table {
	width: -moz-available;
}
</style>
